import WeatherSelectorTileList from 'features/Weather/components/WeatherSelectorTileList/WeatherSelectorTileList';
import WidgetArrow from 'features/Weather/components/WidgetArrow/WidgetArrow';
import { getSelectorListStyle } from './utils/weatherWidgetSelector.utils';

const WeatherWidgetSelector = ({
  items = [],
  selectedIndex = 0,
  onSelect,
  visibleNumOfItems = items.length,
  getTileProps = () => ({}),
  getKey = (item, index) => item?.iso8601 ?? index,
  selectorMode = 'row',
  gridColumnCount = 1,
  gap = 8,
  arrowButtonWidth,
  arrowIconSize,
  containerClassName = '',
  containerStyle,
  listContainerStyle,
  tileClassName = '',
  tileStyle,
  ariaLabel = 'Forecast selector',
  previousButtonLabel = 'Show previous forecast item',
  nextButtonLabel = 'Show next forecast item',
}) => {
  return (
    <div
      aria-label={ariaLabel}
      className={`d-flex align-items-center justify-content-center h-100 w-100 overflow-hidden ${containerClassName}`}
      role="group"
      style={containerStyle}
    >
      <WidgetArrow
        direction="left"
        ariaLabel={previousButtonLabel}
        arrowButtonWidth={arrowButtonWidth}
        arrowIconSize={arrowIconSize}
        selectedItem={selectedIndex}
        numOfItems={items.length}
        setSelectedItem={(nextIndex) => onSelect?.(nextIndex, items[nextIndex])}
      />
      <div
        style={{
          ...getSelectorListStyle({ selectorMode, gridColumnCount, gap }),
          ...listContainerStyle,
        }}
      >
        <WeatherSelectorTileList
          items={items}
          selectedIndex={selectedIndex}
          visibleNumOfItems={visibleNumOfItems}
          onSelect={(item, index) => onSelect?.(index, item)}
          getKey={getKey}
          tileClassName={tileClassName}
          tileStyle={{
            minWidth: 0,
            ...(selectorMode === 'row' ? { flex: '1 1 0' } : {}),
            ...tileStyle,
          }}
          getTileProps={getTileProps}
        />
      </div>
      <WidgetArrow
        direction="right"
        ariaLabel={nextButtonLabel}
        arrowButtonWidth={arrowButtonWidth}
        arrowIconSize={arrowIconSize}
        selectedItem={selectedIndex}
        numOfItems={items.length}
        setSelectedItem={(nextIndex) => onSelect?.(nextIndex, items[nextIndex])}
      />
    </div>
  );
};

export default WeatherWidgetSelector;
